import { Box } from "@mui/system";
import { CampaignDetailsContext } from "pages/dashboard/CampaignDetails";
import { useCallback, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { debounce } from "shared/helpers";
import { requiredRules } from "shared/helpers/validators";
import TextInput from "shared/ui/TextInput";

const SimpleForm = () => {
  const { onSubmit, setAlreadySubmited, refetchSurveyData } = useContext(CampaignDetailsContext);

  const { getValues, reset, trigger } = useFormContext();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSubmit = useCallback(
    debounce(async () => {
      setAlreadySubmited(true);
      reset(getValues());
     await onSubmit(getValues());
      await refetchSurveyData();
    }, 2000),
    []
  );

  const onSubmitHandler = async () => {
    const isValid = await trigger();
    if (!isValid) {
      return;
    }
    debouncedSubmit();
  };

  return (
    <Box
      sx={{
        "& textarea": {
          paddingTop: "25px",
        },
      }}
    >
      <TextInput
        name="title"
        placeholder={"Type your text here"}
        label="Title"
        rules={requiredRules}
        multiline
        onChangeCb={onSubmitHandler}
      />
    </Box>
  );
};
export default SimpleForm;
